import FilterBar from "components/FilterBar";
import Loader from "components/Loader";
import SingleSelect from "components/SingleSelect";
import Text from "components/Text";
import { useView } from "hooks";
import React from "react";
import { User } from "slice/user/types";
import theme from "theme";
import { View } from "utils";
import * as Styled from "./FindTalent.styled";
import TalentCard from "./TalentCard";
import { useFindTalent } from "./useFindTalent";

export const FindTalent: React.FC = React.memo(() => {
    const isTabletView = useView(View.TABLET_768);
    const isMobileView = useView(View.MOBILE_426);
    const {
        users,
        count,
        isFetching,
        inputs,
        handleInputChange,
        handleAgeRangeSelector,
        handleApply,
        handleReset,
        handleSortByChange,
    } = useFindTalent();

    return (
        <Styled.Wrapper>
            <FilterBar
                inputs={inputs}
                handleInputChange={handleInputChange}
                handleAgeRangeSelector={handleAgeRangeSelector}
                handleApply={handleApply}
                handleReset={handleReset}
                handleSortByChange={handleSortByChange}
            />
            <Styled.Right>
                {isFetching && <Loader size={28} />}
                <Styled.Header>
                    <Styled.HeaderText>
                        <Text
                            variant="heading5"
                            fontWeight="700"
                            color={theme.colors.text}
                        >
                            Find Talent
                        </Text>
                        <Styled.CountsWrapper>
                            <Text
                                variant="label"
                                color={theme.colors.purple.primary}
                            >
                                {count} Profiles
                            </Text>
                            <Text
                                className="resultsText"
                                variant="label"
                                color={theme.colors.text}
                            >
                                are found as per filter.
                            </Text>
                        </Styled.CountsWrapper>
                    </Styled.HeaderText>
                    {!isMobileView && (
                        <SingleSelect
                            name="sort_by"
                            label="Sort By"
                            value={inputs.sort_by}
                            options={[
                                {
                                    label: "Relevance",
                                    value: "relevance",
                                },
                                {
                                    label: "Most Recent",
                                    value: "most_recent",
                                },
                            ]}
                            placeholder="Relevance"
                            onChange={handleSortByChange}
                            {...(isTabletView && { minWidth: "10rem" })}
                        />
                    )}
                </Styled.Header>
                <Styled.Body>
                    {users.map((user: User) => (
                        <TalentCard key={user.id} {...user} />
                    ))}
                </Styled.Body>
            </Styled.Right>
        </Styled.Wrapper>
    );
});

FindTalent.displayName = "FindTalent";
